module.exports = __webpack_public_path__ + "img/1.dd8c9a5e.png";